/*
 * @Descripttion: 传贝支付
 * @version: 1.0.0
 * @Author: ck
 * @Date: 2019-10-15 15:48:03
 * @LastEditors: ck
 * @LastEditTime: 2019-10-25 10:53:19
 */

const _load = require('@/routers/_loadPath/_load_' + process.env.NODE_ENV)
let openInterface = _load('product/pay/openInterface/Index')
let splitSystem = _load('product/pay/splitSystem/Index')
let MobileApplyCooperation = _load('product/pay/common/MobileApplyCooperation')
const routes = [{
    path: 'pay/openInterface',
    component: openInterface,
    name: 'openInterface',
    meta: {
      title: '开放接口'
    },
  },
  {
    path: 'pay/splitSystem',
    component: splitSystem,
    name: 'splitSystem',
    meta: {
      title: '传贝分账体系'
    },
  },
  {
    path: 'pay/mobileApplyCooperation',
    component: MobileApplyCooperation,
    name: 'mobileApplyCooperation',
    meta: {
      title: '传贝开发接口申请'
    },
  }
];

export default routes